import { Box } from '@mui/system'
import React from 'react'
import { clientsCard } from '../../styles/style'
import { Typography } from '@mui/material'
import clientlogo from '../../images/clientLogo.png'

export default function OurClientsCard() {
  return (
    <>
                <Box sx={clientsCard} >
                        <Box  sx={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                            <Box sx={{ padding: '20px 30px'}}>
                                <Typography sx={{   fontSize:'16px', lineHeight: '26px', color:'#000'}}>
                                    Lorem ipsum dolor sit ametconsectetur.Lorem ipsum dolor sit amet consectetur.Lorem ipsum dolor sit amet consectetur.
                                </Typography>
                                <Box  sx={{ marginTop: '20px', display: 'flex', alignItems:'center', gap:3}}>
                                    <img style={{width:'42px'}} src={clientlogo} alt="" srcset="" />
                                    <Box sx={{fontFamily:'Inter'}}>
                                        <Typography >Ivan Mathews 1</Typography>
                                        <Typography sx={{fontSize: '14px', fontWeight: 350, color:'#8896AB'}} class="experience-span3">Coach | Sr Developer</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
    </>
  )
}
